// Frame shared by the 811 Ticket Finder reports: a modal with a title and close
// button when a report opens on its own, or just the content when it's embedded in
// the Reports window (which draws its own frame and report-type picker).
export default function ReportShell({ embedded, onClose, title, subtitle, maxWidth = 'max-w-5xl', children }) {
  if (embedded) return <div className="flex flex-col min-h-0 flex-1">{children}</div>;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={onClose}>
      <div
        className={`border rounded-lg w-full ${maxWidth} max-h-[92vh] flex flex-col`}
        style={{ backgroundColor: '#0d1b2e', borderColor: '#1e3a5f' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between p-5 pb-0">
          <div>
            <h2 className="text-lg font-black text-white tracking-widest uppercase">{title}</h2>
            {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white text-xl leading-none px-2" title="Close">✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}
